import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";

function Navbar() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="logo" onClick={() => setMenuOpen(false)}>
          <img src={logo} alt="Klyzen Ventures Logo" />
        </Link>

        {/* Hamburger */}
        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Nav Links */}
        <ul className={`nav-links ${menuOpen ? "open" : ""}`}>
          <li>
            <Link
              to="/"
              className={location.pathname === "/" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Home
            </Link>
          </li>

            <li>
            <Link
              to="/services"
              className={location.pathname === "/services" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Services
            </Link>
          </li>


            <li>
            <Link
              to="/career"
              className={location.pathname === "/career" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Career
            </Link>
          </li>










           <li>
            <Link
              to="/about"
              className={location.pathname === "/about" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              About
            </Link>
          </li>



          {/* <li>
            <Link
              to="/divisions"
              className={location.pathname === "/divisions" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Divisions
            </Link>
          </li> */}



          <li>
            <Link
              to="/contact"
              className={location.pathname === "/contact" ? "active" : ""}
              onClick={() => setMenuOpen(false)}
            >
              Contact
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
